import { render, staticRenderFns } from "./Questionnary.vue?vue&type=template&id=9956474c&"
import script from "./Questionnary.vue?vue&type=script&lang=js&"
export * from "./Questionnary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports